/**
 * @param {HTMLElement} node
 * @param {string} variant
 */
 export default function variant(node, variant) {
	if (variant) {
        node.classList.forEach(classItem => {
            if (!classItem.includes('--')) {
                node.classList.add(`${classItem}--${variant}`);
            }
        });
	}
}